import { render } from "./Chapter9.vue?vue&type=template&id=f55e1482&scoped=true"
import script from "./Chapter9.vue?vue&type=script&lang=js"
export * from "./Chapter9.vue?vue&type=script&lang=js"

import "./Chapter9.vue?vue&type=style&index=0&id=f55e1482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55e1482"]])

export default __exports__